module.exports = __webpack_public_path__ + "img/solid-chevron-down.42c567b7.svg";